<template>
  <div class="page">
    <ul class="pagination" v-show="showFlag">
      <li @click="goFirst" :class="{ isNo:pageData.current===1 }"><a href="javascript:void(0)">首页</a></li>
      <li @click="pageData.current-- && goto(pageData.current)" :class="{ isNo:pageData.current===1 }"><a href="javascript:void(0)">上一页</a></li>
      <li v-for="index in pages" @click="goto(index)" :class="[{'active':pageData.current == index}, pagenum]" :key="index">
        <a href="javascript:void(0)" >{{index}}</a>
      </li>
      <li @click="pageData.current++ && goto(pageData.current)" :class="{ isNo:pageData.current===pageData.allpage }"><a href="javascript:void(0)" >下一页</a></li>
      <li @click="goEnd" :class="{ isNo:pageData.current===pageData.allpage }"><a href="javascript:void(0)" disabled>尾页</a></li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
      pagenum: 'pagenum',
      showFlag: false
    }
  },
  created () {
  },
  props: {
    pageData: {
      type: Object,
      default: function () {
        return {
          current: 1, // 当前页面
          showItem: 5, // 显示的页码个数
          allpage: 13 // 总共的页数
        }
      }
    }
  },
  computed: {
    pages () {
      var pag = []
      if (this.pageData.current < this.pageData.showItem) {
        // 如果当前的激活的项 小于要显示的条数 总页数和要显示的条数那个大就显示多少条
        var i = Math.min(this.pageData.showItem, this.pageData.allpage)
        while (i) {
          pag.unshift(i--)
        }
      } else {
        // 当前页数大于或者等于显示页数了
        var middle = this.pageData.current - Math.floor(this.pageData.showItem / 2)
        i = this.pageData.showItem
        // 当当前为5时，middle是3, i=5
        // 3 > (13 - 5)
        if (middle > (this.pageData.allpage - this.pageData.showItem)) {
          middle = (this.pageData.allpage - this.pageData.showItem) + 1
        }
        while (i--) {
          pag.push(middle++)
        }
      }
      return pag
    }
  },
  methods: {
    goto (index) {
      this.$emit('pageIndex', index)
      if (index === this.pageData.current) {
        return
      }
      if (index < 1) {
        index = 1
        this.pageData.current = 1
      }
      if (index > this.pageData.allpage) {
        this.pageData.current = this.pageData.allpage
        index = this.pageData.allpage
      }
      if (index === this.pageData.current) return
      this.pageData.current = index
    },
    goFirst () {
      this.pageData.current = 1
      this.$emit('pageIndex', this.pageData.current)
    },
    goEnd () {
      this.pageData.current = this.pageData.allpage
      this.$emit('pageIndex', this.pageData.current)
    },
    show () {
      this.showFlag = true
    },
    hide () {
      this.showFlag = false
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  // @import "../../common/less/variable";
  @import '~@/styles/base.scss';
  .page {
    li {
        list-style:none;
        font-size: 14px;
      }
    a {
      text-decoration:none;
    }
    .pagination {
      position: relative;
      width: 440px;
    }
    .pagination li {
      display: inline-block;
      margin:0 5px;
      text-align: center;
      &.isNo {
        pointer-events: none;
        a {
          color: #999;
          // background-color: red;
        }
        a:hover {
          background-color: rgba(0, 0, 0, 0);;
          cursor: auto;
        }
      }
    }
    .pagination li {
      &.active {
        pointer-events: none;
      }
      a {
        // padding:.5rem 1rem;
        display:inline-block;
        height: 26px;
        line-height: 26px;
        width: 50px;
        color:#000;
        // background: color;
        border-radius: 3px;
      }
      &.pagenum a {
        width: 26px;
        height: 26px;
        border-radius: 4px;
      }
    }
    .pagination li a:hover {
      background:#eee;
    }
    .pagination li.active a {
      background:#81A3EB;
      color:#fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination/pagination.vue